import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {CustomField, ICustomField} from 'app/blocks/model/custom-field.model';
import {CustomFieldService} from 'app/blocks/service/api/custom-field.service';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldResource extends AbstractEntityResource<ICustomField> {
    constructor(customFieldService: CustomFieldService, router: Router) {
        super(
            Resource.CUSTOM_FIELDS,
            customFieldService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CUSTOM_FIELDS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CUSTOM_FIELDS),
            (entity?) => new CustomField(entity),
            (entity) => entity.code,
            'priority_high'
        );
    }
}
